export enum AccountRole {
    User = 'user',
    Admin = 'admin',
}
